import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PhonePickerButton from "../components/PhonePickerButton";
import { updateModal } from "../actions/modal";

class PhonePickerButtonContainer extends PureComponent {
  render() {
    const {
      clientConfig,
      filter,
      offerType,
      portalData,
      small,
      updateModal
    } = this.props;

    return (
      <PhonePickerButton
        clientConfig={clientConfig}
        filter={filter}
        offerType={offerType}
        portalData={portalData}
        small={small}
        updateModal={updateModal}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    clientConfig: state.clientConfig,
    filter: state.filter[state.offerType],
    offerType: state.offerType,
    portalData: state.portalData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateModal: (data, type) => {
      dispatch(updateModal(data, type));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhonePickerButtonContainer);
